import React, { useState, useEffect} from 'react'
import './landingBottom.css';
import C2wLandingBottomCrd from '../../../common/C2wSuperxHome/landingBottom/landingBottomCrd';
import C2wMobileLandingBtmCrd from '../../../common/C2wSuperxHome/landingBottom/mobileLandingBtmCrd';

function C2wSuperxLandingBottom() {

    const countArr = [
        { count : 1200, subHeading : 'Participation'},
        { count : 200, subHeading : 'Projects'},
        { count : 10, subHeading : 'Domains'},
        { count : 5, subHeading : 'Startup Partners'},        
]

const renderedC2wLandingBottomCrds = countArr?.map((obj, index) => {
    return <C2wLandingBottomCrd obj={obj} index={index} />

})

const renderedC2wLandingBottomMobileCrds = countArr?.map((obj, index) => {
  return <C2wMobileLandingBtmCrd obj={obj} index={index} />

})

   
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    windowWidth > 620 ? (
    <div className='C2wSuperxLandingBottom_ctn'>
        {renderedC2wLandingBottomCrds}
    </div>
    ) : (
      <div className='C2wSuperxLandingBottom_ctn'>
          {renderedC2wLandingBottomMobileCrds}
      </div>
    )
  )
}

export default C2wSuperxLandingBottom;
